module.exports = __webpack_public_path__ + "static/media/56.7ca9929d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/56.png
// module id = 481
// module chunks = 0